import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72ccf1d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "date" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Date")
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "activity" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Activity")
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "performed-by" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Performed By")
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "date item" }
const _hoisted_12 = { class: "activity item" }
const _hoisted_13 = { class: "performed-by item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("img", {
          src: _ctx.sortIcon,
          alt: "sort"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sort("activity"))),
          src: _ctx.sortIcon,
          alt: "sort"
        }, null, 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("img", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sort("author"))),
          src: _ctx.sortIcon,
          alt: "sort"
        }, null, 8, _hoisted_10)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities, (item) => {
      return (_openBlock(), _createElementBlock("section", {
        class: "body",
        key: item.id
      }, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(item.date), 1),
        _createElementVNode("div", _hoisted_12, _toDisplayString(item.activity), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(item.author), 1)
      ]))
    }), 128))
  ]))
}